exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nstrong[data-v-8e665222] {\n    color: white !important\n}\n\n", "", {"version":3,"sources":["/codebuild/output/src663559002/src/slink-frontend/src/pages/BlogArticle.vue"],"names":[],"mappings":";AACA;IACI,uBAAuB;CAC1B","file":"BlogArticle.vue","sourcesContent":["\nstrong[data-v-8e665222] {\n    color: white !important\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8e665222","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/BlogArticle.vue
// module id = 5AVc
// module chunks = 1